import { render, staticRenderFns } from "./PotentialTopNavigation.vue?vue&type=template&id=069e6bc8&scoped=true"
import script from "./PotentialTopNavigation.vue?vue&type=script&lang=js"
export * from "./PotentialTopNavigation.vue?vue&type=script&lang=js"
import style0 from "./PotentialTopNavigation.vue?vue&type=style&index=0&id=069e6bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069e6bc8",
  null
  
)

export default component.exports